import * as Types from '../Constants/TenantConstants';

// Get all tenants reducer
export const GetAllTenantsReducer = (
  state = { tenants: [], pages: 0, page: 0, loading: false, error: null },
  action
) => {
  switch (action.type) {
    case Types.TENANT_LIST_REQUEST:
      return { ...state, loading: true };

    case Types.TENANT_LIST_SUCCESS:
      return {
        ...state,
        loading: false,
        tenants: action.payload.content,
        pages: action.payload.page.totalPages,
        page: action.payload.page.number,
      };

    case Types.TENANT_LIST_FAIL:
      return { ...state, loading: false, error: action.payload };

    case Types.TENANT_LIST_RESET:
      return { tenants: [], pages: 0, page: 0, loading: false, error: null };

    default:
      return state;
  }
};

// Get all tenants unpaged reducer
export const GetAllTenantsUnpagedReducer = (
  state = { unpagedTenants: [], loading: false, error: null },
  action
) => {
  switch (action.type) {
    case Types.TENANT_LIST_UNPAGED_REQUEST:
      return { ...state, loading: true };

    case Types.TENANT_LIST_UNPAGED_SUCCESS:
      return {
        ...state,
        loading: false,
        unpagedTenants: action.payload,
      };

    case Types.TENANT_LIST_UNPAGED_FAIL:
      return { ...state, loading: false, error: action.payload };

    case Types.TENANT_LIST_UNPAGED_RESET:
      return { unpagedTenants: [], loading: false, error: null };

    default:
      return state;
  }
};

// Get tenant details reducer
export const GetTenantDetailsReducer = (
  state = { tenantDetails: {}, loading: false, error: null },
  action
) => {
  switch (action.type) {
    case Types.TENANT_DETAILS_REQUEST:
      return { ...state, loading: true };

    case Types.TENANT_DETAILS_SUCCESS:
      return { loading: false, tenantDetails: action.payload };

    case Types.TENANT_DETAILS_FAIL:
      return { loading: false, error: action.payload };

    case Types.TENANT_DETAILS_RESET:
      return { tenantDetails: {}, loading: false, error: null };

    default:
      return state;
  }
};

// Create tenant reducer
export const CreateTenantReducer = (state = {}, action) => {
  switch (action.type) {
    case Types.TENANT_CREATE_REQUEST:
      return { loading: true };

    case Types.TENANT_CREATE_SUCCESS:
      return { loading: false, success: true, tenant: action.payload };

    case Types.TENANT_CREATE_FAIL:
      return { loading: false, success: false, error: action.payload };

    case Types.TENANT_CREATE_RESET:
      return {};

    default:
      return state;
  }
};

// Update tenant reducer
export const UpdateTenantReducer = (state = {}, action) => {
  switch (action.type) {
    case Types.TENANT_UPDATE_REQUEST:
      return { loading: true };

    case Types.TENANT_UPDATE_SUCCESS:
      return { loading: false, success: true, tenant: action.payload };

    case Types.TENANT_UPDATE_FAIL:
      return { loading: false, error: action.payload };

    case Types.TENANT_UPDATE_RESET:
      return {};

    default:
      return state;
  }
};

// Delete tenant reducer
export const DeleteTenantReducer = (state = {}, action) => {
  switch (action.type) {
    case Types.TENANT_DELETE_REQUEST:
      return { loading: true };

    case Types.TENANT_DELETE_SUCCESS:
      return { loading: false, success: true };

    case Types.TENANT_DELETE_FAIL:
      return { loading: false, error: action.payload };

    case Types.TENANT_DELETE_RESET:
      return {};

    default:
      return state;
  }
};